// Beside ColorSplitControl rather than in it: a module exporting a component may export nothing
// else, or Vite's Fast Refresh gives up on the whole file.

/** The color a "default / clear" swatch carries — a transparent value matches nothing else. */
export const CLEAR_SWATCH = "rgba(0, 0, 0, 0)"

/** A value matching no swatch, so nothing reads as selected (mixed / no active color). */
const NO_SELECTION = "rgba(1, 2, 3, 0)"

/**
 * Resolve the picker's selected value from a control's active color:
 * a color string selects that swatch; `null` selects the clear/default swatch;
 * `undefined` (mixed across the selection) selects nothing.
 */
export function pickerValue(active: string | null | undefined): string {
  if (active === null) return CLEAR_SWATCH
  if (active === undefined) return NO_SELECTION
  return active
}
